<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">About us</div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                Learn about the program!
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>
    <section>
      <v-container grid-list-xl class=" white-background">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <v-card class="elevation-0 transparent text-center">
              <h2 class="headline pa-2">Strata Inspection Program</h2>

            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <section>
      <v-container grid-list-xl class="white-background" justify-center>
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-container grid-list-xl justify-space-around>
              <v-layout row wrap align-start justify-space-around>
                <v-flex xs12 sm6>
                  <v-card class="elevation-0 transparent" text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">About the Program</div>
                    </v-card-title>
                    <v-card-text>
                      <p>
                        The Strata Inspection Program
                        (SIP) is a project that involves the
                        development and operation of an inspection and
                        assessment program of strata properties in North
                        Queensland. The program aims to increase the total
                        resilience of strata properties in Queensland to the
                        effects of future tropical cyclones by providing Bodies
                        Corporate with information about the existing resilience
                        of their properties and strategies to improve that
                        resilience if needed.
                      </p>
                      <!--<p>
                        The program is administered by the Queensland Government,
                        and independently developed and implemented by James
                        Cook University (JCU).
                      </p>-->
                      <p>
                        Inspections are offered free of cost for strata
                        properties within 100 km of the coast, north of the
                        southernmost boundary of the Rockhampton Regional
                        council area, extending to the Queensland/Northern
                        Territory border, and including islands off the
                        Queensland coast. Properties within 50 km of the coast
                        are in Wind Region C, and properties between 50 and 100
                        km of the coast are in Wind Region B, as shown in the
                        Wind Region map of Queensland.
                      </p>
                      <p>
                        Participation in the program is voluntary. Bodies Corporate
                        should note that most insurance policies include a duty of disclosure
                        that may require notifying the insurer of the results of
                        an inspection under this program.
                      </p>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 justify-center>
                  <v-card class="elevation-0 transparent">
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Wind Regions of Queensland</div>
                    </v-card-title>
                    <v-img
                      :src="require('@/assets/wind-regions.jpg')"
                      aspect-ratio="0.88"
                      max-width="500"
                    ></v-img>
                  </v-card>
                  <v-card-text primary-title class="layout justify-center">
                    <p>
                      Inspections are offered in Region B and Region C as shown
                      above.
                    </p>
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <Footer></Footer>
  </v-content>
</template>

<style></style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";

export default {
  name: "About",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    items: [
      {
        color: "#27C5DA",
        icon: "person",
        header: "1. Appoint an Authorised Person",
        text:
          "The Strata body appoints a representative called the Authorised Person.The Authorised Person is someone who has been voted in by the Body Corporate Committee to represent the property."
      },
      {
        color: "#46B3FD",
        icon: "create",
        header: "2. Register",
        text: "Complete the registration form below on the strata portal."
      },
      {
        color: "#4CABDB",
        icon: "cloud_upload",
        header: "3. Request an insepction",
        text:
          "You will be provided with login details. Login to your account. Fill in information about your site. Submit your site for an inspection."
      },
      {
        color: "#27C5DA",
        icon: "view_headline",
        header: "4. Prepare",
        text:
          "Even before your property is assessed, you can undertake measures to improve the resilience of your property to damage from the effects of tropical cyclones."
      },

      {
        color: "#46B3FD",
        icon: "date_range",
        header: "5. Inspection",
        text: "You will be contacted by an Inspector to schedule the inspection"
      },
      {
        color: "#4CABDB",
        icon: "list_alt",
        header: "6. Report",
        text:
          "Your report will include resilience scores and mitigation options."
      },

      {
        color: "#27C5DA",
        icon: "list",
        header: "7. Mitigation",
        text:
          "Strata Body considers resilience and undertakes selected mitigation options, and may communicates with insurer."
      }
    ]
  }),
  methods: {}
};
</script>
